import React from "react";
import "antd/dist/antd.css";
import Footer from "../landingPage/footer";
import { LoadingOutlined } from "@ant-design/icons";
import NavBar from "../landingPage/header/navbar";
import {
  Input,
  Button,
  Row,
  Col,
  message,
  Layout,
  List,
  Select,
  Avatar,
  Form,
  Modal,
} from "antd";
import axios from "axios";
import "./index.scss";
import { Helmet } from "react-helmet";
import MetaTagContents from "../../MetaTagContents";
import TextConstants from "../../TextConstants";
import { ADD_SITE_VISIT, CONTACT_US } from "../../env";

const { Name, Content } = Layout;
const { TextArea } = Input;

class ContactUsForm extends React.Component {
  formRef = React.createRef();

  state = {
    button_loader: false,
    source: "direct",
    showBusinessFields: false,
    showFooterOptions: false,
  };

  componentDidMount() {
    window.addEventListener("scroll", () => {
      let elmnt = document.getElementById("help-heading");
      if (elmnt && elmnt[0] && elmnt[0].offsetHeight) {
        let updatedElem =
          window.document.getElementsByClassName("navbar-light");
        if (updatedElem && updatedElem[0]) {
          if (window.scrollY > elmnt[0].offsetHeight) {
            updatedElem[0].classList.add("full-opacity");
          } else {
            updatedElem[0].classList.remove("full-opacity");
          }
        }
      }
    });

    const urlParams = new URLSearchParams(window.location.search);
    const shouldShow = urlParams.get("showBusinessFields") === "true";
    this.setState({ showBusinessFields: shouldShow });

    const isFooterClick = urlParams.get("contact-footer") === "true";
    this.setState({ showFooterOptions: isFooterClick });

    const source = urlParams.get("source");
    if (source === "amazon") {
      this.addContactPageVisit();
    }
  }

  addContactPageVisit = ()=> {
    const payload = {
      "page_name" : "contact-us"
    }
    axios
    .post(
      ADD_SITE_VISIT,
      payload
    )
  }

  render() {
    const layout = {
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
    };
    const { showBusinessFields } = this.state;

    const onFinish = (values) => {
      this.setState({
        button_loader: true,
      });

      const {
        firstName,
        lastName,
        email,
        company,
        message,
        messageType,
        companySize,
        businessType,
        companyWebsite,
        jobTitle,
      } = values;

      const { showBusinessFields } = this.state;
      const referrer = "Enterprise Explore"
        ? showBusinessFields
        : "Contact Us Section";
      const data = {
        first_name: firstName,
        last_name: lastName,
        company_website: companyWebsite,
        job_title: jobTitle,
        email,
        referrer,
      };

      if (company) {
        data.company = company;
      }

      if (companySize) {
        data.companySize = companySize;
      }

      if (businessType) {
        data.businessType = businessType;
      }

      if (message) {
        data.message = message;
      }

      if (messageType) {
        data.messageType = messageType;
      }

      data.referrer = showBusinessFields
        ? "Enterprise Explore"
        : "Contact Us Section";

      let pageOrigin = new URLSearchParams(window.location.search).get(
        "origin"
      );
      if (pageOrigin == "portal") {
        data.origin = "portal";
      }

      console.log(JSON.stringify(data));

      axios
        .post(CONTACT_US, data)
        .then((res) => {
          this.formRef.current.resetFields();
          this.setState({
            button_loader: false,
          });
          Modal.success({
            className: "custom-success-modal",
            content: (
              <div className="modal-success-content">
                Thanks for reaching out! We'll get back to you right away.
              </div>
            ),
          });
        })
        .catch((error) => {
          this.setState({
            button_loader: false,
          });
          message.error("Error in sending message.");
        });
    };

    const { title, text, link_text, options, company_sizes, business_types } =
      TextConstants.CONTACT_US_FORM;
    return (
      <React.Fragment>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{MetaTagContents.CONTACT_US_FORM.title}</title>
          <link rel="canonical" href="https://all3d.ai/contact-us" />
          <meta name={Name} content={Content} />
        </Helmet>

        <div>
          <NavBar />
          <Layout className="margin-above-footer">
            <Content>
              <Row className="reverse">
                <Row className="container-row">
                  <div className="help-form-container">
                    <Col
                      xxl={8}
                      lg={8}
                      offset={0}
                      className="row-large-screen left-margin"
                    >
                      <h1
                        style={{ marginTop: "170px" }}
                        className="help-header"
                      >
                        {title}
                      </h1>

                      <div className="contact-help-text">{text} <a href="https://blog.all3d.ai" target="_blank">here</a></div>
                      <div
                        style={{ marginTop: "32px", display: "flex" }}
                        className="row-large-screen"
                      >
                        <a
                          href={"https://app.all3d.ai/"}
                          className="sign-in-ref"
                        >
                          {link_text}
                        </a>
                        <div>
                          <img
                            src="arrow-right.svg"
                            style={{ marginLeft: "15px" }}
                            alt="Sign In"
                          />
                        </div>
                      </div>
                    </Col>
                    <div className="row-large-screen space-columns"></div>
                    <Col xxl={8} lg={8} className="form-column">
                      <div
                        style={{ height: 80 }}
                        className="row-large-screen"
                      ></div>
                      <div>
                        <Form
                          {...layout}
                          name="nest-messages"
                          onFinish={onFinish}
                          className="form-margin"
                          ref={this.formRef}
                        >
                          <Form.Item className="form-padding">
                            <Form.Item
                              name="firstName"
                              style={{
                                display: "inline-block",
                                width: "calc(50% - 8px)",
                                marginBottom: "0px",
                              }}
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter first name!",
                                },
                              ]}
                            >
                              <Input
                                className="name-placeholder"
                                placeholder="First Name *"
                              />
                            </Form.Item>
                            <Form.Item
                              name="lastName"
                              style={{
                                display: "inline-block",
                                width: "calc(50% - 8px)",
                                marginBottom: "0px",
                                marginLeft: "16px",
                              }}
                              rules={[
                                {
                                  required: true,
                                  message: "Please enter last name!",
                                },
                              ]}
                            >
                              <Input
                                className="name-placeholder"
                                placeholder="Last Name *"
                              />
                            </Form.Item>
                          </Form.Item>
                          <Form.Item
                            name="email"
                            rules={[
                              {
                                required: true,
                                message: "Please enter a valid email!",
                                type: "email",
                              },
                            ]}
                          >
                            <Input
                              className="other-placeholder"
                              placeholder="Email Address *"
                            />
                          </Form.Item>
                          <Form.Item name="company" rules={[
                              {
                                required: true,
                              message: "Please enter a valid company name!",
                              },
                            ]}>
                            <Input
                              className="other-placeholder"
                              placeholder="Company Name *"
                            />
                          </Form.Item>
                          <Form.Item name="companyWebsite" rules={[
                              {
                                required: true,
                              message: "Please enter a company website!",
                              },
                            ]}>
                            <Input
                              className="other-placeholder"
                              placeholder="Company Website *"
                            />
                          </Form.Item>
                          <Form.Item name="jobTitle" rules={[
                              {
                                required: true,
                              message: "Please enter a valid job title!",
                              },
                            ]}>
                            <Input
                              className="other-placeholder"
                              placeholder="Job Title *"
                            />
                          </Form.Item>
                          {showBusinessFields && (
                            <Form.Item>
                              <Row gutter={16}>
                                <Col span={12}>
                                  <Form.Item name="companySize" noStyle>
                                    <Select placeholder="Company Size">
                                      {company_sizes.map((x) => (
                                        <Select.Option key={x} value={x}>
                                          {x}
                                        </Select.Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                </Col>
                                <Col span={12}>
                                  <Form.Item name="businessType" noStyle>
                                    <Select placeholder="Business Type">
                                      {business_types.map((x) => (
                                        <Select.Option key={x} value={x}>
                                          {x}
                                        </Select.Option>
                                      ))}
                                    </Select>
                                  </Form.Item>
                                </Col>
                              </Row>
                            </Form.Item>
                          )}

                          <Form.Item name="messageType" id="select-message" rules={[
                            {
                              required: true,
                              message: "Please enter a valid message type!",
                            },
                          ]}>
                            <Select placeholder="Message Type *">
                              {(this.state.showFooterOptions
                                ? TextConstants.CONTACT_US_FORM.footer_options
                                : TextConstants.CONTACT_US_FORM.options
                              ).map((x) => (
                                <Select.Option key={x} value={x}>
                                  {x}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                          <Form.Item name="message">
                            <Input.TextArea
                              className="text-area-placeholder"
                              placeholder="What do you need help with?"
                              rows={6}
                            />
                          </Form.Item>
                          <Form.Item
                            wrapperCol={{ ...layout.wrapperCol, offset: 8 }}
                            className="button-margin-top"
                          >
                            <div>
                              <Button
                                disabled={this.state.button_loader}
                                type="primary"
                                htmlType="submit"
                                id="submit-btn"
                              >
                                <span className="submit-btn-text">
                                  Submit{" "}
                                  {this.state.button_loader ? (
                                    <LoadingOutlined />
                                  ) : (
                                    ""
                                  )}
                                </span>
                              </Button>
                            </div>
                          </Form.Item>
                        </Form>
                      </div>
                    </Col>
                  </div>
                </Row>
                <Row className="container-row row-small-screen">
                  <div className="help-heading-container">
                    <Col>
                      <h2
                        style={{ marginTop: "170px" }}
                        className="help-header"
                        id="help-heading"
                      >
                        {title}
                      </h2>
                      <div className="contact-help-text">{text}</div>
                    </Col>
                  </div>
                </Row>
              </Row>
            </Content>
          </Layout>
          <div className="abs-btm">
            <Footer />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ContactUsForm;
